import numeral from "numeral";

export function timeStringFromSeconds(time: number | null | undefined, showMilliseconds = false, showSeconds = true) {
  if (time == null || !Number.isFinite(time)) {
    return "";
  }
  // we need to account for negative values as well
  const absTime = Math.abs(time);
  const negative = time < 0 ? "-" : "";

  const hours = Math.floor(absTime / (60 * 60));
  const minutes = Math.floor((absTime - hours * 60 * 60) / 60);
  const seconds = Math.floor(absTime % 60);
  const milliseconds = (absTime % 1) * 1000;

  // if the time is exactly 0, return 00:00:00
  if (absTime === 0) {
    if (showMilliseconds) {
      return "00:00:00.000";
    }
    if (showSeconds) {
      return "00:00:00";
    }
    return "00:00";
  }
  // if the time is below 1 second we will always give the milliseconds
  if (absTime < 1) {
    return `${negative}0.${numeral(absTime * 1000).format("000")}`;
  }
  // if the time is below 1 minute we will always give the seconds, no matter what, but respect the other flag
  if (absTime < 60) {
    if (showMilliseconds) {
      return `${negative}${numeral(seconds).format("00")}.${numeral(milliseconds).format("000")}`;
    }
    return `${negative}${numeral(seconds).format("00")}`;
  }
  // otherwise use the flags as normal but show seconds if show milliseconds is requested
  const mainString = `${negative}${hours > 0 ? `${numeral(hours).format("00")}:` : ""}${numeral(minutes).format("00")}`;
  if (showMilliseconds) {
    return `${mainString}:${numeral(seconds).format("00")}.${numeral(milliseconds).format("000")}`;
  }
  if (showSeconds) {
    return `${mainString}:${numeral(seconds).format("00")}`;
  }
  return `${mainString}`;
}
